import { gsap } from '../global/gsap';

const initMenu = (element) => {
    const body = document.querySelector('.js-body');
    const menuToggle = document.querySelectorAll('.js-menu-button');
    const menuClose = document.querySelector('.js-menu-close');
    const menuText = document.querySelector('.header__menu-text');
    const stopScrollingClass = 'stop-scrolling';
    const menuActiveClass = 'menu-active';
    let menuActive = false;
    const searchToggle = document.querySelector('.js-search-button');
    const searchActiveClass = 'search-active';
    const searchInput = document.querySelector('.js-search-form input');
    let searchActive = false;
    const menuAccordions = document.querySelectorAll(
        '.menu-item:has(.sub-menu)',
    );

    menuClose.addEventListener('click', () => {
        body.classList.remove(
            stopScrollingClass,
            menuActiveClass,
            searchActiveClass,
        );
        menuText.textContent = 'Menu';
        searchActive = false;
        menuActive = false;
    });

    menuToggle.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            menuActive = !menuActive;

            if (menuActive) {
                body.classList.add(stopScrollingClass, menuActiveClass);
                body.classList.remove(searchActiveClass);
                searchActive = false;
                menuText.textContent = 'Close';
            } else {
                body.classList.remove(
                    stopScrollingClass,
                    menuActiveClass,
                    searchActiveClass,
                );
                menuText.textContent = 'Menu';
                searchActive = false;
            }
        });
    });

    searchToggle.addEventListener('click', (e) => {
        e.preventDefault();
        searchActive = !searchActive;

        if (searchActive) {
            body.classList.add(stopScrollingClass, searchActiveClass);
            body.classList.remove(menuActiveClass);
            menuText.textContent = 'Menu';
            menuActive = false;
            searchInput.focus();
        } else {
            body.classList.remove(
                stopScrollingClass,
                searchActiveClass,
                menuActiveClass,
            );
        }
    });

    menuAccordions.forEach((accordion) => {
        const firstLink = accordion.querySelector('a');
        const subMenu = accordion.querySelector('.sub-menu');
        let subMenuHeight = subMenu.offsetHeight;
        let isActive = false;

        // Set submenu height to 0
        gsap.to(subMenu, {
            height: 0,
            overflow: 'hidden',
        });

        // Duplicate first link and modify text
        if (firstLink && subMenu) {
            const clonedLink = firstLink.cloneNode(true);
            const originalText = clonedLink.textContent.trim();

            // Change the link title if necessary
            switch (originalText.toLowerCase()) {
            case 'about':
                clonedLink.textContent = 'About us';
                break;
            case 'projects':
                clonedLink.textContent = 'All projects';
                break;
            default:
                break;
            }

            const listItem = document.createElement('li');
            listItem.appendChild(clonedLink);

            // Add it to the start of the submenu
            subMenu.insertBefore(listItem, subMenu.firstChild);

            // Measure the height after the duped link has been dropped in
            subMenuHeight = subMenu.offsetHeight;
        }

        // Toggle Accordion Logic
        firstLink.addEventListener('click', (e) => {
            e.preventDefault();
            isActive = !isActive;

            firstLink.classList.toggle('is-active', isActive);

            if (isActive) {
                gsap.to(subMenu, {
                    height: `${subMenuHeight}px`,
                    duration: 0.375,
                    ease: 'power3.inOut',
                });
            } else {
                gsap.to(subMenu, {
                    height: '0',
                    duration: 0.375,
                    ease: 'power3.inOut',
                });
            }
        });

        // accordion.addEventListener('click', (e) => {
        //     console.log(e.target);
        //     if (e.target === accordion) {
        //         e.preventDefault();
        //     }
        // });
    });
};

export { initMenu as default };
